import { useState, useEffect } from "react";
import { Download, X, Smartphone } from "lucide-react";

/**
 * Shows a bottom-sheet install prompt when the browser fires "beforeinstallprompt".
 * Dismissed by the user or after they accept. Remembers dismissal in sessionStorage.
 */
export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("pwa-dismissed")) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setVisible(false);
    sessionStorage.setItem("pwa-dismissed", "1");
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-20 left-3 right-3 md:left-auto md:right-4 md:w-80 z-50 animate-slide-up"
      data-testid="pwa-install-prompt"
    >
      <div className="bg-white rounded-2xl border border-border shadow-xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground leading-tight">
            Instalar RedeCicatriza
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Adicione ao seu dispositivo para acesso rápido, mesmo offline.
          </p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={handleDismiss}
              className="flex-1 py-2 border border-border rounded-lg text-xs font-medium hover:bg-secondary transition-all"
              data-testid="pwa-dismiss-btn"
            >
              Agora não
            </button>
            <button
              onClick={handleInstall}
              className="flex-1 flex items-center justify-center gap-1.5 py-2 bg-primary text-primary-foreground rounded-lg text-xs font-medium hover:bg-primary/90 transition-all"
              data-testid="pwa-install-btn"
            >
              <Download className="w-3 h-3" /> Instalar
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="p-1 rounded-md hover:bg-secondary transition-all flex-shrink-0"
        >
          <X className="w-3.5 h-3.5 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
